import React, { useState, useEffect } from "react";
import { Card, Button, Form, Dropdown, Table } from "react-bootstrap";
import { FaFilter, FaDownload, FaInfoCircle, FaFileInvoice, FaVideo } from "react-icons/fa";
import "./Partner.css";


const Monetization_Details = () => {
    const [selectedMonth, setSelectedMonth] = useState("January 2025");
    const [selectedMonthearn, setSelectedMonthEarn] = useState("January 2025");

    const [currentEarningsearn, setCurrentEarningsEarn] = useState([
        {
            title: "Video 1",
            views: 1000,
            subscriptionEarnings: "$200.00",
            ppvEarnings: "$150.00",
            commission: "$70.00",
            finalEarnings: "$280.00",
        },
        {
            title: "Video 2",
            views: 1500,
            subscriptionEarnings: "$300.00",
            ppvEarnings: "$200.00",
            commission: "$100.00",
            finalEarnings: "$400.00",
        },
        {
            title: "Video 2",
            views: 1500,
            subscriptionEarnings: "$300.00",
            ppvEarnings: "$200.00",
            commission: "$100.00",
            finalEarnings: "$400.00",
        },
        {
            title: "Video 2",
            views: 1500,
            subscriptionEarnings: "$300.00",
            ppvEarnings: "$200.00",
            commission: "$100.00",
            finalEarnings: "$400.00",
        },
        {
            title: "Video 2",
            views: 1500,
            subscriptionEarnings: "$300.00",
            ppvEarnings: "$200.00",
            commission: "$100.00",
            finalEarnings: "$400.00",
        },
        {
            title: "Video 2",
            views: 1500,
            subscriptionEarnings: "$300.00",
            ppvEarnings: "$200.00",
            commission: "$100.00",
            finalEarnings: "$400.00",
        },
        {
            title: "Video 2",
            views: 1500,
            subscriptionEarnings: "$300.00",
            ppvEarnings: "$200.00",
            commission: "$100.00",
            finalEarnings: "$400.00",
        },
    ]);
    const transactions = {
        "January 2025": {
            paidAmount: "$245,678.90",
            paidDate: "Jan 16, 2025",
            pendingAmount: "$0.00",
            nextPayout: "Feb 15, 2025",
        },
        "February 2025": {
            paidAmount: "$280,500.00",
            paidDate: "Feb 16, 2025",
            pendingAmount: "$5,000.00",
            nextPayout: "Mar 15, 2025",
        },
    };
    const revenueData = {
        "Last 3 months": [
            { month: "Nov", amount: "$27.3k", growth: "+10%" },
            { month: "Dec", amount: "$29.9k", growth: "+9%" },
            { month: "Jan", amount: "$32.4k", growth: "+8%" },
        ],
        "Last 6 months": [
            { month: "Aug", amount: "$21.5k", growth: "+12%" },
            { month: "Sep", amount: "$23.2k", growth: "+8%" },
            { month: "Oct", amount: "$24.8k", growth: "+7%" },
            { month: "Nov", amount: "$27.3k", growth: "+10%" },
            { month: "Dec", amount: "$29.9k", growth: "+9%" },
            { month: "Jan", amount: "$32.4k", growth: "+8%" },
        ],
        "Last 12 months": [
            { month: "Feb", amount: "$19.8k", growth: "+5%" },
            { month: "Mar", amount: "$20.3k", growth: "+6%" },
            { month: "Apr", amount: "$22.7k", growth: "+7%" },
            { month: "May", amount: "$24.1k", growth: "+9%" },
            { month: "Jun", amount: "$25.6k", growth: "+10%" },
            { month: "Jul", amount: "$26.8k", growth: "+11%" },
            { month: "Aug", amount: "$21.5k", growth: "+12%" },
            { month: "Sep", amount: "$23.2k", growth: "+8%" },
            { month: "Oct", amount: "$24.8k", growth: "+7%" },
            { month: "Nov", amount: "$27.3k", growth: "+10%" },
            { month: "Dec", amount: "$29.9k", growth: "+9%" },
            { month: "Jan", amount: "$32.4k", growth: "+8%" },
        ],
    };
    const defaultEarningsData = [
        {
            title: "Advanced Photography Tips",
            views: "12,450",
            subscriptionEarnings: "$1,245.00",
            ppvEarnings: "$320.00",
            commission: "-$313.00",
            finalEarnings: "$1,252.00",
        },
        {
            title: "Lighting Masterclass",
            views: "8,320",
            subscriptionEarnings: "$832.00",
            ppvEarnings: "$450.00",
            commission: "-$256.40",
            finalEarnings: "$1,025.60",
        },
    ];

    const earningsDataByMonth = {
        "January 2025": [
            { title: "Advanced Photography Tips", views: 5000, subscriptionEarnings: "$500", ppvEarnings: "$200", commission: "-$140", finalEarnings: "$560" },
            { title: "Lighting Masterclass", views: 3200, subscriptionEarnings: "$320", ppvEarnings: "$120", commission: "-$88", finalEarnings: "$352" },
        ],
        "December 2024": [
            { title: "Advanced Photography Tips", views: 4000, subscriptionEarnings: "$400", ppvEarnings: "$180", commission: "-$116", finalEarnings: "$464" },
            { title: "Lighting Masterclass", views: 2500, subscriptionEarnings: "$250", ppvEarnings: "$100", commission: "-$70", finalEarnings: "$280" },
        ],
    };
 const currentEarnings = earningsDataByMonth[selectedMonth] || defaultEarningsData;
 const currentEarningsEarn = earningsDataByMonth[selectedMonthearn] || defaultEarningsData;
    
    const [selectedRange, setSelectedRange] = useState("Last 6 months");

    const currentData = transactions[selectedMonth] || {};
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5; // Number of items per page

    const handleDownloadReport = () => {
        const reportContent = `
        Monetization Report - ${selectedMonth}

        Paid Amount: ${currentData.paidAmount}
        Paid Date: ${currentData.paidDate}
        Pending Amount: ${currentData.pendingAmount}
        Next Payout: ${currentData.nextPayout}
        `;

        const blob = new Blob([reportContent], { type: "text/plain" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Monetization_Report_${selectedMonth}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDownloadReportEarn = () => {
        const reportContent = `
    Earnings Report:
    
    ${defaultEarningsData
                .map(
                    (item, index) => `
    ${index + 1}. Title: ${item.title}
       Views: ${item.views}
       Subscription Earnings: ${item.subscriptionEarnings}
       PPV Earnings: ${item.ppvEarnings}
       Commission: ${item.commission}
       Final Earnings: ${item.finalEarnings}
    `
                )
                .join("\n")}`;

        const blob = new Blob([reportContent], { type: "text/plain" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Earnings_Report.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const getTotalEarnings = () => {
        const totalSubscription = currentEarningsearn.reduce(
            (sum, item) => sum + parseFloat(item.subscriptionEarnings.replace("$", "")),
            0
        );
        const totalPpv = currentEarningsearn.reduce(
            (sum, item) => sum + parseFloat(item.ppvEarnings.replace("$", "")),
            0
        );
        const totalCommission = currentEarningsearn.reduce(
            (sum, item) => sum + parseFloat(item.commission.replace("$", "")),
            0
        );
        const totalFinalEarnings = currentEarningsearn.reduce(
            (sum, item) => sum + parseFloat(item.finalEarnings.replace("$", "")),
            0
        );
        return { totalSubscription, totalPpv, totalCommission, totalFinalEarnings };
    };

    const handlePagination = (direction) => {
        if (direction === "prev" && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        } else if (direction === "next") {
            setCurrentPage(currentPage + 1);
        }
    };
    const paginatedData = currentEarningsearn.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const { totalSubscription, totalPpv, totalCommission, totalFinalEarnings } = getTotalEarnings();

    // useEffect(() => {
    //     setCurrentEarningsEarn(earningsDataByMonth[selectedMonthearn] || []);
    //   }, [selectedMonthearn]);
      
    return (
        <>
            <h4>Monetization Details</h4>
            <div className="container mt-4">
                <div className="partner-dashboard d-flex justify-content-between align-items-center mb-3 p-3">
                    <div className="d-flex align-items-center gap-2">
                        <Form.Select className="small-dropdown" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                            <option>January 2025</option>
                            <option>February 2025</option>
                        </Form.Select>
                    </div>
                    <div className="d-flex gap-2">
                        <Button variant="primary" className="filter-btn">
                            <FaFilter className="me-1" /> Apply Filter
                        </Button>
                        <Button variant="outline-secondary" className="export-btn" onClick={handleDownloadReport}>
                            <FaDownload className="me-1" /> Export Report
                        </Button>
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-4">
                        <Card className="p-3 d-flex flex-column align-items-start">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className="text-secondary">Total Earnings</span>
                                <FaInfoCircle className="text-secondary" />
                            </div>
                            <span className="fw-bold text-dark fs-4">$245,678.90</span>
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className="text-secondary">Subscription: $28,200</span>
                                <span className="text-secondary">PPV: $4,250</span>
                            </div>
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <Card className="p-3 d-flex flex-column align-items-start">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className="text-secondary">Admin Commission</span>
                                <span className="text-secondary">20%</span>
                            </div>
                            <span className="fw-bold text-danger fs-4">-$198,432.50</span>
                            <span className="text-secondary">Applied to total revenue</span>
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <Card className="p-3 d-flex flex-column align-items-start">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className="text-secondary">Net Earnings</span>
                                <FaInfoCircle className="text-secondary" />
                            </div>
                            <span className="fw-bold text-success fs-4">$47,246.40</span>
                            <span className="text-secondary">After Commission deduction</span>
                        </Card>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Card className="p-3 d-flex flex-column align-items-start">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className="text-secondary">Paid Amount</span>
                                <span className="fw-bold text-primary d-flex align-items-center">
                                    <FaFileInvoice className="ms-2" /> View Invoice
                                </span>
                            </div>
                            <span className="fw-bold text-dark fs-4">{currentData.paidAmount}</span>
                            <span className="text-secondary text-small">Paid on {currentData.paidDate}</span>
                        </Card>
                    </div>
                    <div className="col-md-6">
                        <Card className="p-3 d-flex flex-column align-items-start">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className="text-secondary">Pending Amount</span>
                                <span className="badge bg-warning text-dark">Processing</span>
                            </div>
                            <span className="fw-bold text-dark fs-4">{currentData.pendingAmount}</span>
                            <span className="text-secondary text-small">Next payout: {currentData.nextPayout}</span>
                        </Card>
                    </div>
                </div>
                <div className="card p-3" style={{ width: "100%" }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold">Monthly Revenue Trends</h6>
                        <Dropdown onSelect={(eventKey) => setSelectedRange(eventKey)}>
                            <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                                {selectedRange}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {Object.keys(revenueData).map((range) => (
                                    <Dropdown.Item key={range} eventKey={range}>
                                        {range}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>

                    <div className="revenue-container">
                        <div className="d-flex gap-3 revenue-scroll">
                            {revenueData[selectedRange].map((data, index) => (
                                <div key={index} className="month-card p-3 rounded text-center">
                                    <span className="text-secondary d-block">{data.month}</span>
                                    <span className="fw-bold d-block">{data.amount}</span>
                                    <span className="text-success d-block">{data.growth}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="earnings-card py-2">
                    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center px-2">
                        <h6 className="fw-bold">Content Earnings Breakdown</h6>
                        <div className="d-flex align-items-center gap-3 mt-3 mt-sm-0">
                            <Form.Select
                                className="dropdown-select"
                                value={selectedMonthearn}
                                onChange={(e) => setSelectedMonthEarn(e.target.value)}
                            >
                                <option>January 2025</option>
                                <option>December 2024</option>
                            </Form.Select>
                            <Button variant="primary" className="earnings-filter-button">
                                <FaFilter className="filter-icon me-1" /> Filter
                            </Button>
                        </div>
                    </div>

                    <div className="scrollable-table-wrapper">
                        <Table className="earnings-table mt-3">
                            <thead className="table-light">
                                <tr>
                                    <th>CONTENT TITLE</th>
                                    <th>VIEWS</th>
                                    <th>SUBSCRIPTION EARNINGS</th>
                                    <th>PPV EARNINGS</th>
                                    <th>COMMISSION (20%)</th>
                                    <th>FINAL EARNINGS</th>
                                    <th>ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedData.length > 0 ? (
                                    paginatedData.map((data, index) => (
                                        <tr key={index}>
                                            <td>
                                                <FaVideo className="video-icon" /> {data.title}
                                            </td>
                                            <td>{data.views}</td>
                                            <td className="text-success">{data.subscriptionEarnings}</td>
                                            <td className="text-success">{data.ppvEarnings}</td>
                                            <td className="text-danger">{data.commission}</td>
                                            <td className="fw-bold">{data.finalEarnings}</td>
                                            <td>
                                                <FaDownload className="download-icon" />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No earnings data available.
                                        </td>
                                    </tr>
                                )}
                                <tr className="fw-bold total-earnings-row">
                                    <td>Total</td>
                                    <td>
                                        {currentEarningsearn.reduce((sum, item) => sum + item.views, 0)}
                                    </td>
                                    <td className="text-success">${totalSubscription.toFixed(2)}</td>
                                    <td className="text-success">${totalPpv.toFixed(2)}</td>
                                    <td className="text-danger">${totalCommission.toFixed(2)}</td>
                                    <td>${totalFinalEarnings.toFixed(2)}</td>
                                    <td>
                                        <Button
                                            variant="primary"
                                            className="export-btn"
                                            onClick={handleDownloadReportEarn}
                                        >
                                            <FaDownload className="export-icon" /> Export All
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between p-2">
                        <span>
                            Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                            {Math.min(currentPage * itemsPerPage, currentEarningsearn.length)} of{" "}
                            {currentEarningsearn.length} items
                        </span>
                        <div className="per-nxt">
                            <Button
                                variant="light"
                                className="me-2"
                                disabled={currentPage === 1}
                                onClick={() => handlePagination("prev")}
                            >
                                Previous
                            </Button>
                            <Button
                                variant="light"
                                disabled={currentPage * itemsPerPage >= currentEarningsearn.length}
                                onClick={() => handlePagination("next")}
                            >
                                Next
                            </Button>
                        </div>
                    </div>       
                 </div> 
             </div>
        </>
    );
};

export default Monetization_Details;
